<script lang="typescript">
  import { useMachine } from '../../common/myrobot';
  import Panel from '../../common/Panel.svelte';

  import { create } from './jitsi';
  import type { JitsiSettings } from './jitsi';
  export let settings:JitsiSettings;
  const machine = create(settings);
  const { context, send, state } = useMachine(machine);
  const save = () => send('save');
  $: settings = $context.settings;
  $: isSaving = $state == "saving";
  $: disabled = isSaving;
  $:error = $context.error;
</script>

<div>
  <h1>Jitsi asetukset</h1>
  <form on:submit|preventDefault={save}>
    <p>
    <label for="pk">Jitsi private key</label>
    <textarea rows=20 name="pk" id="pk" bind:value={settings.private_key}></textarea>
    </p>
    <p>
    <label for="api-key">Api key</label>
    <input required bind:value={settings.api_key} name="api-key" id="api-key" type=text>
    </p>
    <p>
    <label for="app-id">App id</label>
    <input required bind:value={settings.app_id} name="app-id" id="app-id" type=text>
    </p>
    {#if isSaving}
      <p>
      <i class="fas fa-spinner fa-spin fa-lg"></i> Tallennetaan...
      </p>
    {/if}
    <p>
    <input {disabled} type=submit value="Tallenna">
    </p>
  </form>
  {#if error}
    <Panel type="error">
      <p>Virhe ohjaajan lisäyksessä.</p>
      <div>
      {@html error}
      </div>
    </Panel>
  {/if}
</div>

<style>
  label {
    display: block;
  }
  textarea {
    width: 80%;
  }
  input[type="text"] {
    width: 80%;
  }

</style>

